import { render, staticRenderFns } from "./IoTDeviceView.vue?vue&type=template&id=0af1bc6c&scoped=true"
import script from "./IoTDeviceView.vue?vue&type=script&lang=ts"
export * from "./IoTDeviceView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1bc6c",
  null
  
)

export default component.exports